<template>
  <div class="container-second-style">
    <UserOverview />
    <CourseRecord />
    <Revenue />
  </div>
</template>

<script>
import "../../assets/scss/_adminStyle.scss";
import UserOverview from "../../components/adminComponent/dashboard/UserOverview";
import CourseRecord from "../../components/adminComponent/dashboard/CourseRecord";
import Revenue from "../../components/adminComponent/dashboard/Revenue";

import "../../assets/scss/_chineseStyle.scss";

export default {
  name: "Dashboard",
  components: {
    UserOverview,
    CourseRecord,
    Revenue,
  },
  created() {
    this.$store.commit("language/setChangingSidebar", true);
  },
};
</script>
